import { createContext, ReactNode, useContext } from 'react';

import { getRefundDataForWebStorage } from '@/components/tax-refund/lookup/result/utils.ts';
import { BusinessType, LookupResultRefundDataContextType } from '@/lib/types/request';

interface Props {
  children: ReactNode;
  businessType: BusinessType;
}

const LookupResultRefundDataContext = createContext<LookupResultRefundDataContextType>({
  businessType: '' as BusinessType,
  displayName: '',
  refundId: '',
  refundAmount: 0,
  refundStatus: '',
  snmcSpcTxreAmt: 0,
  cenSnmcTxreAmt: 0,
  empIncrEtrpTxamtDdcAmt: 0,
  intgEmpTxamtDdcAmt: 0,
  sctyInfeeTxamtDdcAmt: 0,
  tritxRefundInfo: undefined
});

export const useLookupResultRefundData = () => useContext<LookupResultRefundDataContextType>(LookupResultRefundDataContext);

export const LookupResultContextProvider = ({ children, businessType }: Props) => {
  const {
    displayName,
    refundAmount,
    refundId,
    refundStatus,
    tritxRefundInfo,
    snmcSpcTxreAmt,
    cenSnmcTxreAmt,
    empIncrEtrpTxamtDdcAmt,
    intgEmpTxamtDdcAmt,
    sctyInfeeTxamtDdcAmt
  } = getRefundDataForWebStorage(businessType);

  return (
    <LookupResultRefundDataContext.Provider
      value={{
        businessType,
        displayName,
        refundId,
        refundAmount: parseInt(refundAmount || '0', 10),
        refundStatus,
        snmcSpcTxreAmt,
        cenSnmcTxreAmt,
        empIncrEtrpTxamtDdcAmt,
        intgEmpTxamtDdcAmt,
        sctyInfeeTxamtDdcAmt,
        tritxRefundInfo
      }}
    >
      {children}
    </LookupResultRefundDataContext.Provider>
  );
};
